import { signal } from '@preact/signals';
import { fetchOrders } from '@/api';

export const orders = signal([]);
export const ordersLoading = signal(false);
export const ordersError = signal(null);

export async function loadOrders() {
  ordersLoading.value = true;
  ordersError.value = null;
  try {
    const data = await fetchOrders();
    orders.value = data.items ?? [];
  } catch (err) {
    ordersError.value = err;
  } finally {
    ordersLoading.value = false;
  }
}
